/* import __COLOCATED_TEMPLATE__ from './freelancer-is-blocked.hbs'; */
import LSGModalBase from './lsg/lsg-modal-dialog-base';
import { closeModal } from "sh-www/utils/modal-controls";

export default LSGModalBase.extend({
  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @type {String}
     */
    freelancerUserName: '',

    /**
     * @type {String}
     */
    freelancerSlug: ''
  },

  /**
   * @inheritDoc
   */
  _onClose() {
    //nothing to do here
  },

  actions: {
    closeModal() {
      closeModal(this);
    },
  },
});
